import { NavLink } from 'react-router-dom';
import { IconChangeLoClock, PermissionEnum, Select } from '@ui/src';
import { BeneficiaryStatus } from '../../../../hoc/common/beneficiaries/types';
import { BeneficiaryStatusContentTypes } from '../types';
import { CustomerStatus } from '../../../../hoc/common/types';

import cn from '../styles.module.css';

const BeneficiaryStatusContent = ({
  beneficiaryStatus,
  beneficiary,
  setBeneficiaryStatus,
  organizationStatus,
  setRejectPopupVisible,
  activePermissions,
}: BeneficiaryStatusContentTypes) => (
  <div className={cn.statusWrapper}>
    <Select
      name="status"
      title="Status"
      value={beneficiaryStatus}
      selectWrapperClassName={cn.beneficiaryStatus}
      list={[
        {
          name: 'Draft',
          value: BeneficiaryStatus.DRAFT,
          hidden: beneficiary.status !== BeneficiaryStatus.DRAFT,
        },
        {
          name: 'Under Review',
          value: BeneficiaryStatus.UNDER_REVIEW,
          hidden: beneficiary.status === BeneficiaryStatus.APPROVED,
        },
        {
          name: 'Approved',
          value: BeneficiaryStatus.APPROVED,
          hidden: beneficiary.status === BeneficiaryStatus.DRAFT,
        },
        {
          name: 'Rejected',
          value: BeneficiaryStatus.REJECTED,
          hidden: beneficiary.status === BeneficiaryStatus.DRAFT,
        },
      ]}
      onChange={(e) => {
        setBeneficiaryStatus(e.target.value as BeneficiaryStatus);

        if (e.target.value === BeneficiaryStatus.REJECTED) {
          setRejectPopupVisible(true);
        }
      }}
      disabled={
        beneficiary.status === BeneficiaryStatus.REJECTED ||
        organizationStatus === CustomerStatus.CLOSED
      }
    />
    {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
      <div className={cn.logsButtonWrapper}>
        <NavLink
          className={cn.logsButton}
          target="_blank"
          to={`/administration/change-logs?entityType=BENEFICIARY&entityId=${beneficiary.id}`}
        >
          <IconChangeLoClock />
          Change log
        </NavLink>
      </div>
    )}
  </div>
);

export default BeneficiaryStatusContent;
